import { subscribe } from "../util/pubsub";

const nav = () => {
    const nav = document.getElementById('nav');
    const filter_mobile = document.getElementById('filters_mobile_toggle');
    if (filter_mobile) {
        filter_mobile.addEventListener('click', function () {
            const p = document.querySelector('.filters_mobile');
            if (!p) return;
            p.classList.toggle('open');
            const d = document.querySelector('.main_content');
            if (!d) return;
            d.classList.toggle('hidden');
        });
    }


    const third_line = document.querySelector('.menu-third-line');
    const dropdowns = Array.from(document.querySelectorAll('[data-dropdown]'));
    const togglers = Array.from(document.querySelectorAll('[data-toggles]'));

    /* sorry, was bored */
    const map = (el, f) => {
        if (!el) return el;
        return Array.isArray(el) ? el.map(e => f(e)) : f(el);
    }
    const class_action = action => c => el => map(el, e => e.classList[action](c));
    const class_remover = class_action('remove');
    const is_open = class_action('contains')('open');
    const show = class_action('add')('open');
    const activate = class_action('add')('active');
    const hide = el => class_remover('open')(el);
    const deactivate = el => class_remover('active')(el);
    const is_mobile = el => el.getAttribute('data-dropdown').indexOf('mobile') !== -1;
    togglers.forEach((link) => {
        link.addEventListener('click', () => {
            const target = document.querySelector('[data-dropdown="' + link.getAttribute('data-toggles') + '"]');
            const open = is_open(target);
            hide(dropdowns);
            deactivate(togglers);
            if (!open) {
                show(target);
                activate(link);
                document.body.classList.add('menu-open');
                if (!is_mobile(target)) {
                    show(third_line);
                }
            } else {
                document.body.classList.remove('menu-open');
                deactivate(link);
                hide(third_line);
            }
        });
    });

    subscribe('WIDTH_BRACKET_CHANGED', () => {
        hide(third_line);
        hide(dropdowns);
        document.body.classList.remove('menu-open');
        deactivate(togglers);
    });

    subscribe('OPEN_MENU', () => {
        nav.classList.add('open');
        const d = document.querySelector('.main');
        document.body.classList.add('menu-open');
        if (!d) return;
        d.classList.add('hidden');
        hide(third_line);
        hide(dropdowns);
        deactivate(togglers);
    });

    subscribe('CLOSE_MENU', () => {
        nav.classList.remove('open');
        const d = document.querySelector('.main');
        document.body.classList.remove('menu-open');
        if (!d) return;
        d.classList.remove('hidden');
        hide(third_line);
        hide(dropdowns);
        deactivate(togglers);
    });
};

nav();